<template lang="pug">
form.columns.align-center.my-2(@submit.prevent="onFilter")
  .pb-1.column.col-auto(v-if="isEnabledFilter('numero_eq')")
    small {{ filters.numero_eq }}
    input.form-input.input-sm(v-model="q.numero_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('pessoas_cpf_cnpj_eq')")
    small {{ filters.pessoas_cpf_cnpj_eq }}
    input-cpf-cnpj.form-input.input-sm(v-model="q.pessoas_cpf_cnpj_eq")
  .pb-1.column.col-auto(
    v-if="isEnabledFilter('contribuinte_razao_social_cont')"
  )
    small {{ filters.contribuinte_razao_social_cont }}
    input.form-input.input-sm(v-model="q.contribuinte_razao_social_cont")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_imobiliario_zona_eq')")
    small {{ filters.cadastro_imobiliario_zona_eq }}
    input.form-input.input-sm(v-model="q.cadastro_imobiliario_zona_eq")
  .pb-1.column.col-auto(
    v-if="isEnabledFilter('cadastro_imobiliario_quadra_eq')"
  )
    small {{ filters.cadastro_imobiliario_quadra_eq }}
    input.form-input.input-sm(v-model="q.cadastro_imobiliario_quadra_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_imobiliario_lote_eq')")
    small {{ filters.cadastro_imobiliario_lote_eq }}
    input.form-input.input-sm(v-model="q.cadastro_imobiliario_lote_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('tipo_eq')")
    small {{ filters.tipo_eq }}
    select-cadastro-tipo.form-select.select-sm(v-model="q.tipo_eq")
  .column.col-auto.pb-1
    small Ordenar por
    order-by(:fields="orderByFields", :query="q", sm)
  .column.col-auto
    .columns.label-padding-top
      .column
        enabled-filters(
          localStorageKey="osm_cadastros_enabled_filters",
          :defaultEnabledFilters="defaultEnabledFilters",
          :enabledFilters="enabledFilters",
          :filters="filters",
          :query="q",
          :setEnabledFilters="setEnabledFilters"
        )
      .column
        button.btn.btn-sm.btn-link.tooltip.tooltip-left(
          data-tooltip="Filtrar",
          :disabled="$v.q.$invalid"
        )
          i.fa.fa-search.fa-lg
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter"

export default {
  data() {
    return {
      filters: {
        numero_eq: this.$options.filters.tModel("cadastro.numero"),
        pessoas_cpf_cnpj_eq: this.$options.filters.tModel("pessoa.cpf_cnpj"),
        contribuinte_razao_social_cont: this.$options.filters.tModel(
          "contribuinte.razao_social",
        ),
        cadastro_imobiliario_zona_eq: this.$options.filters.tModel(
          "cadastro_imobiliario.zona",
        ),
        cadastro_imobiliario_quadra_eq: this.$options.filters.tModel(
          "cadastro_imobiliario.quadra",
        ),
        cadastro_imobiliario_lote_eq: this.$options.filters.tModel(
          "cadastro_imobiliario.lote",
        ),
        tipo_eq: this.$options.filters.tModel("cadastro.tipo"),
      },
      defaultEnabledFilters: ["numero_eq", "pessoas_cpf_cnpj_eq"],
      orderByFields: {
        numero: this.$options.filters.tModel("cadastro.numero"),
        zona: this.$options.filters.tModel("cadastro.zona"),
        quadra: this.$options.filters.tModel("cadastro.quadra"),
        lote: this.$options.filters.tModel("cadastro.lote"),
        updated_at: this.$options.filters.tModel("cadastro.updated_at"),
      },
    }
  },
  validations: {
    q: {},
  },
  vuex: { cadastros: defaultStoreImports },
  mixins: [filterMixin],
}
</script>
